export const RESET_PASSENGERS_TO_BE_DELETED = 'RESET_PASSENGERS_TO_BE_DELETED'

export default () => ({
  type: RESET_PASSENGERS_TO_BE_DELETED,
})
